module.exports = __webpack_public_path__ + "media/images/games/clash-royale/kl-background-e57787d3e915727d4e2e709c137b0787.svg";